import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Typography, Container, Grid, Paper, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { setUser } from '../../../store/slices/userSlice';
const SignInForm = () => {
  const { t } = useTranslation('auth');
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const auth = getAuth();
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      if (!user.emailVerified) {
        await signOut(auth);
        throw new Error('Please verify your email before signing in.');
      }
      const token = await user.getIdToken();
      dispatch(setUser({
        email: user.email,
        id: user.uid,
        token: token,
      }));
      navigate('/optimizer');
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}
    >
      <Paper elevation={3} style={{ padding: '20px', width: '100%' }}>
        <Typography component="h1" variant="h5" align="center">
          {t('signIn.title')}
        </Typography>
        <form onSubmit={handleSubmit} style={{ margin: '20px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label={t('signIn.email')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                label={t('signIn.password')}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Grid>
          </Grid>
          <Button type="submit" fullWidth variant="contained" color="primary" style={{ marginTop: '16px' }}>
            {t('signIn.submit')}
          </Button>
        </form>
        {error && <Typography color="error" align="center">{error}</Typography>}
        <Grid container justifyContent="center" style={{ marginTop: '16px' }}>
          <Grid item>
            <Typography variant="body2" align="center">
              {t('signIn.noAccount')}{' '}
              <Link href="/signup" variant="body2">
                {t('signIn.signUpLink')}
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};
export default SignInForm;
